export const convertMinutesToHours = (n: number) =>
    `0${(n / 60) ^ 0}`.slice(-2) + ':' + ('0' + (n % 60)).slice(-2)
